import { Flex } from '@mantine/core';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import Container from 'components/ui/Container';
import Loader from 'components/ui/Loader';
import AccreditationPage from 'pages/lk/AccreditationPage';
import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';
import { useDevices } from 'utils/devices';

import Header from '../Header';
import SideMenu from '../SideMenu';
import { useLkLayoutConfig } from '../useLkLayoutConfig';

import s from './LkLayoutContent.module.scss';

const LkLayoutContent: React.FC = () => {
  const { isTablet } = useDevices();
  const { menu } = useLkLayoutStore();
  const {
    isProfilePage,
    shouldShowHeader,
    shouldUseDetailHeight,
    shouldShowAccreditationBanner,
    withHeaderBottomPadding,
  } = useLkLayoutConfig();
  const pageContent = (
    <div className={cn(s.root__content, isProfilePage && s.root__content_profile)}>
      <React.Suspense fallback={<Loader fullHeight />}>
        <Outlet />
      </React.Suspense>
    </div>
  );

  return (
    <Flex className={cn(s.root, shouldUseDetailHeight && s.root__detail, isProfilePage && s.root_profile)} gap={4}>
      <SideMenu />
      {isProfilePage || shouldShowAccreditationBanner ? (
        <div className={s.root__page}>
          {isTablet && menu.isOpen && <div className={s.root__backdrop} onClick={menu.close} aria-hidden />}
          {shouldShowHeader && (
            <Container className={s['root__profile-header__container']}>
              <Header withBottomPadding={withHeaderBottomPadding} className={s['root__profile-header']} />
            </Container>
          )}
          {isProfilePage && pageContent}
          {!isProfilePage && shouldShowAccreditationBanner && <AccreditationPage />}
        </div>
      ) : (
        <Container className={s.root__page}>
          {isTablet && menu.isOpen && <div className={s.root__backdrop} onClick={menu.close} aria-hidden />}
          {shouldShowHeader && <Header withBottomPadding={withHeaderBottomPadding} />}
          {pageContent}
        </Container>
      )}
    </Flex>
  );
};

export default observer(LkLayoutContent);
